import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Dealer_URL } from "../../Essentials/variables";


const fetchDealers=createAsyncThunk('dealers/fetch',async()=>{
    const response = await axios.get(Dealer_URL);
    return response.data;
})

export {fetchDealers}